import { batchActions } from "redux-batched-actions";
import { displayErrorMessage } from '@insticator/insticator-ui'; // iui-utils
// api
import { asyncGetCommentingUnitCode } from 'utils/api/commenting';

// constants
export const RECEIVE_COMMENTING_UNIT_CODE = 'RECEIVE_COMMENTING_UNIT_CODE';
export const FETCHING_COMMENTING_UNIT_CODE = 'FETCHING_COMMENTING_UNIT_CODE';

// actions
const receiveCommentingUnitCode = data => ({
    type: RECEIVE_COMMENTING_UNIT_CODE,
    data
});

const fetchingCommentingUnitCode = status => ({
    type: FETCHING_COMMENTING_UNIT_CODE,
    status
});

// batched actions

const commentingUnitCodeSuccess = (data) => batchActions([receiveCommentingUnitCode(data), fetchingCommentingUnitCode(false)]);
const commentingUnitCodeFail = () => batchActions([displayErrorMessage('There was a problem fetching Ratings Unit Code.'), fetchingCommentingUnitCode(false)]);

// thunks

export const getCommentingUnitCode = (siteUUID, enablePageId) => dispatch => {
    dispatch(fetchingCommentingUnitCode(true))
    asyncGetCommentingUnitCode(siteUUID, enablePageId)
        .then(response => dispatch(commentingUnitCodeSuccess(response.data)))
        .catch(err => dispatch(commentingUnitCodeFail()))
};

